<template>

  <b-form @submit.prevent>
    <b-row>
      <b-col md="4">
        <b-form-group
            label="Nom"
            label-for="libelle"

        >
          <b-form-input
              :class="{'is-invalid' : form_errors.libelle}"
              v-model="site.libelle"
              id="libelle"
              placeholder="Nom du site"
          />
          <small v-if="form_errors.libelle" class="text-danger">{{ form_errors.libelle[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
            label="Concession"
            label-for="concession"
            :class="{'is-invalid' : form_errors.concession}"
        >
          <v-select id="concession" v-model="site.concession"
                    :options="$store.state.initialConfigModule.initialState.concessions"

                    label="libelle"/>
          <small v-if="form_errors.concession" class="text-danger">{{ form_errors.concession[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
            label="Ville"
            label-for="ville"
            :class="{'is-invalid' : form_errors.ville}"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.ville}"
              v-model="site.ville"
              id="libelle"
              placeholder="Ville"
          />
          <small v-if="form_errors.ville" class="text-danger">{{ form_errors.ville[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="Ville Avito"
            label-for="avito_city"
            :class="{'is-invalid' : form_errors.avito_city_id}"
        >
          <v-select id="avito_city" v-model="site.avito_city_id"
                    :options="avitoCities"
                    label="libelle"
                    :reduce="city => city.id"
                    placeholder="Sélectionner une ville Avito"/>
          <small v-if="form_errors.avito_city_id" class="text-danger">{{ form_errors.avito_city_id[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="Zone Avito"
            label-for="avito_area"
            :class="{'is-invalid' : form_errors.avito_area_id}"
        >
          <v-select id="avito_area" v-model="site.avito_area_id"
                    :options="avitoAreas"
                    label="libelle"
                    :reduce="area => area.id"
                    placeholder="Sélectionner une zone Avito"/>
          <small v-if="form_errors.avito_area_id" class="text-danger">{{ form_errors.avito_area_id[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="Identifiant Réseau Spoticar"
            label-for="identifiant_reseau_spoticar"
            :class="{'is-invalid' : form_errors.identifiant_reseau_spoticar}"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.identifiant_reseau_spoticar}"
              v-model="site.identifiant_reseau_spoticar"
              id="identifiant_reseau_spoticar"
              placeholder="Boutique Avito"
          />
          <small v-if="form_errors.identifiant_reseau_spoticar" class="text-danger">{{ form_errors.identifiant_reseau_spoticar[0] }}</small>
        </b-form-group>
      </b-col>


      <b-col md="6">
        <b-form-group
            label="Boutique Avito"
            label-for="id_boutique"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.id_boutique}"
              v-model="site.id_boutique"
              id="id_boutique"
              placeholder="Boutique Avito"
          />
          <small v-if="form_errors.id_boutique" class="text-danger">{{ form_errors.id_boutique[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="Showroom_c Salesforce"
            label-for="showroom_c"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.showroom_c}"
              v-model="site.showroom_c"
              id="showroom_c"
              placeholder="Showroom_c Salesforce"
          />
          <small v-if="form_errors.showroom_c" class="text-danger">{{ form_errors.showroom_c[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
            label="Adresse"
            label-for="adresse"
            :class="{'is-invalid' : form_errors.adresse}"
        >
           <b-form-textarea v-model="site.adresse"></b-form-textarea>
          <small v-if="form_errors.adresse" class="text-danger">{{ form_errors.adresse[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-button

            type="submit"
            variant="primary"
            class="mr-1"
            @click="submit"
        >
          Enregistrer
        </b-button>

      </b-col>
    </b-row>

  </b-form>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


export default {
  name: 'SiteForm',
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    initialSite: {
      default: false,
    }
  },
  methods: {
    submit() {
      let _this = this;
      _this.form_errors = {};
      this.$store.dispatch('siteModule/siteStore', this.site).then(function (response) {
        _this.$emit('submited', response);
        _this.$router.push('/sites')
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          _this.form_errors = error.response.data.errors;
        }
      })
    },
    fetchAvitoCities() {
      let _this = this;
      this.$store.dispatch('siteModule/fetchAvitoCities').then(function (response) {
        _this.avitoCities = response.data;
      }).catch(function (error) {
        console.error('Error fetching Avito cities:', error);
      });
    },
    fetchAvitoAreas() {
      let _this = this;
      this.$store.dispatch('siteModule/fetchAvitoAreas').then(function (response) {
        _this.avitoAreas = response.data;
      }).catch(function (error) {
        console.error('Error fetching Avito areas:', error);
      });
    }
  },
  created() {
    this.site = {...this.initialSite};
    this.fetchAvitoCities();
    this.fetchAvitoAreas();
  },
  data() {
    return {
      site: {
        libelle: '',
        concession: '',
        avito_city_id: null,
        avito_area_id: null
      },
      avitoCities: [],
      avitoAreas: [],
      form_errors: {}
    }
  },
}
/*
<ul class="chosen-results"><li class="active-result result-selected" data-option-array-index="1" style="">MR</li><li class="active-result" data-option-array-index="2" style="">COMPANY</li><li class="active-result" data-option-array-index="3" style="">GARAGE</li><li class="active-result" data-option-array-index="4" style="">MESSRS</li><li class="active-result" data-option-array-index="5" style="">MME</li><li class="active-result" data-option-array-index="6" style="">MMES</li><li class="active-result" data-option-array-index="7" style="">MS</li></ul>
 */
</script>
